<template>
  <div style="height: 400px">
    <GridVx
      ref="agGrid"
      dom-layout="scroll"
      :columns="columns"
      :rows="bookingDetailStore.sub_booking_group_surcharges"
      row-selection="single"
      class="agGrid"
    />
  </div>
</template>

<script>
import { dateFormatter } from '@/utils/dataFormatter'
import { bookingDetailStore } from '../stores/'

export default {
  data() {
    return {
      columns: [
        {
          headerName: 'Mã',
          minWidth: 100,
          field: 'room_surcharge_code'
        },
        {
          headerName: 'Mô tả',
          minWidth: 100,
          field: 'desc'
        },
        {
          headerName: 'Giá đơn vị',
          minWidth: 100,
          field: 'price',
          valueFormatter(params) {
            return params.value === null
              ? ''
              : Intl.NumberFormat().format(params.value)
          }
        },
        {
          headerName: 'Số lượng',
          minWidth: 100,
          field: 'quantity'
        },
        {
          headerName: 'Từ ngày',
          minWidth: 100,
          field: 'start_date',
          valueFormatter: params => {
            return dateFormatter(params.value)
          }
        },
        {
          headerName: 'Đến ngày',
          minWidth: 100,
          field: 'end_date',
          valueFormatter: params => {
            return dateFormatter(params.value)
          }
        },

        {
          headerName: 'Ghi chú',
          field: 'note'
        }
      ],
      bookingDetailStore
    }
  }
}
</script>

<style></style>
